const isLocalhost = __DEMO_OR_DEV__ && window.location.hostname === 'localhost'
export const demoOrDevPrefix = isLocalhost ? '#url-in-prod---->' : ''
